import Arrow from './Arrow';
import Close from './Close';
import CloseImageModal from './CloseImageModal';
import Logo from './Logo';
import MinimizeImageModal from './MinimizeImageModal';
import Snackbar_Error from './Snackbar_Error';
import Snackbar_Success from './Snackbar_Success';
import Snackbar_Warning from './Snackbar_Warning';
import User from './User';

import dot from 'dot-object';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';

/**
 * Objeto mapa dos ícones genéricos da aplicação
 */
const iconsMap = {
  arrow: Arrow,
  close: Close,
  closeImageModal: CloseImageModal,
  logo: Logo,
  minimizeImageModal: MinimizeImageModal,
  snackbar: {
    success: Snackbar_Success,
    warning: Snackbar_Warning,
    error: Snackbar_Error,
  },
  user: User,
};

/**
 * Componente que visa agrupar os ícones utilizados de forma geral na
 * aplicação, tanto na view de mapa como a administrativa
 */
const Icon = ({ i, ...props }) => {
  const splittedReference = i.split('-');
  if (splittedReference[0] !== 'all') {
    return <p>Ícone não existe</p>;
  } else {
    splittedReference.shift();
    const IconComponent = dot.pick(splittedReference.join('.'), iconsMap);
    if (IconComponent) {
      return <IconComponent {...props} />;
    } else {
      return <p>Ícone não existe</p>;
    }
  }
};

Icon.propTypes = {
  /** Identificação do ícone desejado. Ex: `all-snackbar-success`  */
  i: PropTypes.string.isRequired,
};

export default Icon;
export {
  Arrow,
  Close,
  CloseImageModal,
  Snackbar_Success,
  Snackbar_Warning,
  Snackbar_Error,
  Logo,
  MinimizeImageModal,
  User,
};
